export const ANALYTICS_GRID_KEY_PREFIX = "analytics:";

// Keyed by the run parameters so a new run never inherits an old run's sort/page.
export const analyticsGridKey = (
  ...parts: Array<string | number | null | undefined>
) =>
  `${ANALYTICS_GRID_KEY_PREFIX}${JSON.stringify(parts.map((part) => part ?? ""))}`;
